import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-memberPrivileges",
  "use": "icon-memberPrivileges-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-memberPrivileges\"><defs><style type=\"text/css\"></style></defs><path d=\"M11.377778 0h1001.244444v1001.244444H11.377778z\" fill=\"#FFFFFF\" fill-opacity=\"0\" p-id=\"2911\" /><path d=\"M739.851378 120.149333l243.598222 276.548267L507.448889 869.944889 31.402667 396.6976 275.023644 120.149333h464.827734zM712.704 180.224H302.148267l-188.279467 213.742933 393.557333 391.281778 393.580089-391.281778L712.704 180.224z m-89.383822 114.460444v66.059378h-220.273778V294.684444h220.273778z\" fill=\"#1A1A1A\" p-id=\"2912\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/memberPrivileges.svg
// module id = vfgA
// module chunks = 97